import React, {useState, useRef} from 'react';
import BCMSSelectData from "./BCMSSelectData.js";
import {isRegistered} from "../BCMSRegistry/main.jsx";

/*
MAIN :: PROPS {
  value: *              - "Value" passed to BCMSSelect when this item is selected
  label: STIRNG         - STRING which is shown when item is selected
  onSelect: FUNCTION    -  Is applied to data of item when clicked
  isSelected: FUNCTION  - Is applied to data when initialized
}
*/

export default function BCMSSelectItem(props) {

  const data = BCMSSelectData.init(props.value, props.label);
  const elem = useRef(null);

  const updateSelected = (evt) => {
    if (typeof(props.onSelect) === "function") {
      props.onSelect(data);
    }
  }

  // Uses passed"isSelected" function to determine if this item is selected in it's drowp down or not
  const setClassName = () => {
    if (typeof(props.isSelected) === "function") {
      return props.isSelected(data) ? "bcms-select-item selected" : "bcms-select-item"
    }
    return "bcms-select-item";
  }

  // Renders component:
  return (
    <div onClick={updateSelected} className={setClassName()} ref={elem}>
      {React.Children.count(props.children) > 0 ? props.children : data.label}
    </div>

  );
}
